<div class="w-full h-full flex flex-col bg-blue-50">
  <dnv-navbar #navbar (menuToggle)="onMenuToggle()"/>
  <mat-drawer-container autosize class="h-full !bg-blue-50">
    <mat-drawer class="!bg-blue-50" #drawer mode="push" position="start" [style.width.px]="180" (closed)="navbar.closeMenu()">
      <dnv-side-menu (closeMenu)="drawer.close()"></dnv-side-menu>
    </mat-drawer>

    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
